function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var u = "2.2.0";
function l(e) {
  var n = function n(o) {
      return "type" in o && typeof o.type == "string" && o.type.length > 0;
    },
    s = function s(o) {
      return "version" in o && typeof o.version == "number" && o.version > 0;
    },
    t = function t(o) {
      return "payload" in o && o.payload !== void 0;
    };
  return _typeof(e) == "object" && e !== null && n(e) && s(e) && t(e);
}
var i;
(function (e) {
  var n;
  (function (t) {
    t.INJECT_STYLES = "INJECT_STYLES";
  })(n = e.MessageType || (e.MessageType = {}));
  function s(t) {
    return !l(t) || !Object.values(n).includes(t.type) ? !1 : t.type === "INJECT_STYLES" && t.version <= 1;
  }
  e.validateMessageDataStructure = s;
})(i || (i = {}));
var r;
(function (e) {
  var n;
  (function (t) {
    t.INIT = "INIT";
  })(n = e.MessageType || (e.MessageType = {}));
  function s(t) {
    return !l(t) || !Object.values(n).includes(t.type) ? !1 : t.type === "INIT" && t.version <= 1;
  }
  e.validateMessageDataStructure = s;
})(r || (r = {}));
var p = {
    Host: i,
    Client: r
  },
  c = {
    LOCAL: ["http://localhost:*", "http://127.0.0.1:*"],
    QA: ["http://localhost:*", "http://127.0.0.1:*", "https://config.us-west-2.qa.cashstar.com", "https://config.cashstar.net", "https://cc.cashstar.net"],
    SEMI: ["http://localhost:*", "http://127.0.0.1:*", "https://config.us-west-2.qa.cashstar.com", "https://config.cashstar.net", "https://cc.cashstar.net"],
    PROD: ["https://config.cashstar.net", "https://cc.cashstar.net"]
  };
function a(e) {
  return "[AMS-IFRAME-INJECTOR] ".concat(e);
}
function d(e, n) {
  var s = function s(t) {
    return new RegExp("^".concat(t.replace(/\./g, "\\.").replace(/\*/g, "[\\w.-_]+"), "/?$"));
  };
  return n.some(function (t) {
    return s(t).test(e);
  });
}
function g(e, n, s) {
  var t = e.data;
  if (!i.validateMessageDataStructure(t)) {
    console.debug(a("Event data doesnt match AMS structure, skipping."));
    return;
  }
  if (!d(e.origin, n)) {
    console.error(a("Event origin is not in allowed hosts list, skipping."));
    return;
  }
  switch (t.type) {
    case i.MessageType.INJECT_STYLES:
      if (t.version === 1) {
        f(t.payload.styles, s);
        return;
      }
  }
  console.warn(a("Unhandled event"), e.data);
}
function f(e, n) {
  var s = document.getElementById(n);
  s || (s = document.createElement("style"), s.id = n, document.head.append(s)), s.textContent = e, console.info(a("Successfully injected new styles."));
}
function y(e, n) {
  var s;
  e in c ? s = c[e] : (console.error(a("Environment '".concat(e, "' is not found, falling back to PROD."))), s = c.PROD), window.addEventListener("message", function (t) {
    return g(t, s, n);
  }), console.info(a("Successfully added message listener"), {
    currentEnv: e,
    styleElementId: n,
    packageVersion: u
  });
}
function h(e) {
  if (!window.top) {
    console.error(a("Failed to send message because window.top is null."));
    return;
  }
  window.top.postMessage(e, "*");
}
function T(e) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ams-iframe-injector-styles";
  try {
    y(e, n);
  } catch (s) {
    console.error(a("Error while adding message listener"), s);
  }
  try {
    h({
      type: r.MessageType.INIT,
      version: 1,
      payload: {}
    });
  } catch (s) {
    console.error(a("Error while sending message that client side is initiated."), s);
  }
}
var w = {
  addMessageListener: T
};
function M(e, n) {
  var s;
  (s = e.contentWindow) == null || s.postMessage(n, "*");
}
function v(e, n) {
  M(e, {
    type: i.MessageType.INJECT_STYLES,
    version: 1,
    payload: {
      styles: n
    }
  });
}
function S(e) {
  var n = function n(s) {
    var t = s.data;
    r.validateMessageDataStructure(t) && e(t);
  };
  return window.addEventListener("message", n), n;
}
function m(e) {
  window.removeEventListener("message", e);
}
var E = {
    injectStyles: v,
    addMessageListener: S,
    removeMessageListener: m
  },
  L = {
    client: w,
    host: E,
    messages: p
  };
export { L as default };
